/* 列傳各章共用的小工具：調等級、加入友軍武將與他的簡單電腦、首領、各勢力的兵、換操作的武將 */
// @ts-nocheck
import { SG } from '../core/sg.ts';
import { H } from '../heroes/define.ts';

export const hero = (id) => SG.HEROES.find((h) => h.id === id);

// 升到 lv 級（已經比較高就不動）
export function setLevel(w, u, lv) {
  const need = SG.expToLevel(lv) - u.exp;
  if (need > 0) w.addExp(u, need / w.tune.exp + 1, true);
}

// 友軍武將：不走一般電腦（human＋npc），由 allyTick 操作；技能照等級自動配好
export function ally(w, spec, x, y, lv, team = 0) {
  const u = w.addHero(typeof spec === 'string' ? hero(spec) : spec, team, false);
  u.human = true; u.npc = true;
  const [px, py] = SG.MAP.walkable(x, y, SG.MAP.BODY) ? [x, y] : SG.MAP.nearestFree(x, y);
  u.x = px; u.y = py;
  setLevel(w, u, lv);
  u.skillLv = SG.skillLevels(u.spec, u.lv).L; w.recalc(u); u.hp = u.maxHp; u.mp = u.maxMp;
  return u;
}
// 友軍武將的電腦：range 內有敵人就打（偶爾放技能），沒有就跟著帶頭的人；u.hold 設成座標就守在那裡
export function allyTick(w, u, lead, range = 520) {
  const I = u.input;
  if (!u.alive) return;
  const at = u.hold || [u.x, u.y];
  let foe = null, bd = range;
  for (const t of w.units) if (w.isEnemy(u, t) && t.team !== 2 && !t.asleep) { const d = SG.gd(at[0], at[1], t.x, t.y); if (d < bd) { bd = d; foe = t; } } // 熟睡、不知情的敵人不去惹
  if (foe) {
    I.target = foe; I.engage = true;
    if (!u.act && SG.rand() < 0.04) { const i = [0, 1, 2, 3].find((k) => u.cd[k] <= 0 && u.skillLv[k] > 0); if (i !== undefined) I.skill = { i, x: foe.x, y: foe.y }; }
    return;
  }
  I.target = null; I.engage = false;
  if (u.hold) { if (SG.gd(u.x, u.y, u.hold[0], u.hold[1]) > 60) I.moveTo = u.hold.slice(); return; }
  if (lead && lead.alive && SG.gd(u.x, u.y, lead.x, lead.y) > 260) I.moveTo = [lead.x - 110 * lead.f, lead.y + 50];
}

// 首領：會放技能的野怪（數值直接給）
export function boss(w, spec, x, y, o) {
  const [px, py] = SG.MAP.walkable(x, y, SG.MAP.BODY) ? [x, y] : SG.MAP.nearestFree(x, y);
  const u = SG.unit(Object.assign({ kind: 'creep', caster: true, spec, team: 1, x: px, y: py, home: [px, py], f: -1, r: 28, hp: 3000, maxHp: 3000, atk: 50, armor: 6, asp: 100, ms: 250, range: 85,
    gold: 300, xp: 500, name: spec.name, think: 0, skillLv: [1, 1, 1, 1], cd: [2, 4, 6, 10] }, o || {}));
  if (o && o.hp && !o.maxHp) u.maxHp = o.hp;
  w.units.push(u);
  return u;
}

// 各勢力的兵：以魏兵的樣子換顏色
export function troop(id, name, c, base) {
  const b = base || SG.SOLDIERS.wei, t = Object.assign({}, b, { id, name, faction: 'neutral', c: Object.assign({}, b.c, c) });
  delete t._anims; delete t._ghost;
  return t;
}
export const TROOPS = {
  dong: troop('dong-soldier', '涼州兵', { armor: '#6a3a2a', sleeve: '#4a2a20', cloth: '#4a2a20', plume: '#c0503a' }), // 董卓軍
  liuyao: troop('liuyao-soldier', '劉繇兵', { armor: '#5d6a78', sleeve: '#3f4a56', cloth: '#3f4a56', plume: '#9aa7b5' }),
  shanzei: troop('shanzei', '山賊', { armor: '#5a5040', sleeve: '#4a4034', cloth: '#4a4034', plume: '#7a6a50', metal: '#6a6a60' }),
  huangzu: troop('huangzu-soldier', '黃祖兵', { armor: '#3e5a5a', sleeve: '#2e4646', cloth: '#2e4646', plume: '#6a9a8a' }),
  yuan: troop('yuan-soldier', '袁軍', { armor: '#7a5a2a', sleeve: '#5a4220', cloth: '#5a4220', plume: '#d0a040' }), // 袁紹軍
  wei: SG.SOLDIERS.wei, shu: SG.SOLDIERS.shu, wu: SG.SOLDIERS.wu,
};

// 從場上拿掉（武將陣亡會復活，劇情退場要直接移除）
export function vanish(w, u) { w.units = w.units.filter((o) => o !== u); }

// 潰逃：不能被打、往 to 跑，5 秒後消失
export function rout(m, w, list, to) {
  for (const u of m.alive(list)) { u.rout = true; u.untargetable = true; u.target = null; u.aggro = null; u.patrol = null; u.search = null; u.home = to.slice(); u.ms = 300; }
  m.after(5, () => { for (const u of list) if (u.alive) { u.alive = false; u.counted = true; u.deadT = w.t; } });
}

// 換操作的武將（劇情切換主角）：舊的交給 allyTick，新的接手鍵盤滑鼠
export function swapPlayer(w, u) {
  const old = w.player;
  if (old === u) return;
  old.isPlayer = false; old.npc = true; old.input = {};
  u.isPlayer = true; u.npc = false; u.human = true; u.input = {};
  if (!u.manual) { const lv = u.skillLv.slice(); w.setManual(u); u.skillLv = lv; u.pts = Math.max(0, u.lv - lv.reduce((a, b) => a + b, 0)); w.recalc(u); }
  w.player = u;
}

// 史書上有名、但不是可選武將的人：用通用的招式。中立的人沒有勢力配色，先墊一套暗色的底
const NEUTRAL_C = { armor: '#5a4a3a', sleeve: '#3a3028', cloth: '#3a3028', trim: '#b8a060', pants: '#2a2420', boot: '#2a2018', cape: null, belt: '#5a3a22', metal: '#8e979f', hood: '#3a3028', pole: '#5a3a22', plume: '#b8a060', band: '#b8a060' };
const P = (id, name, sub, faction, role, weapon, look, skills) => H(id, name, sub, faction, role, weapon, Object.assign({ fx: '#ffd8a0' }, look, faction === 'neutral' ? { c: Object.assign({}, NEUTRAL_C, look.c) } : {}), skills); // fx：招式特效的顏色（沒給會讓漸層出錯）
export const PEOPLE = {
  zumao: P('zumao', '祖茂', '孫堅部將', 'wu', '戰士', 'sword', { c: { cape: '#c0302a' } }, [
    ['橫刀', 'crescent', '揮刀造成 {80/80/80/80} 傷害。'], ['突進', 'charge', '衝撞造成 {60/60/60/60} 傷害。'], ['迴斬', 'spin', '每圈 {40/40/40/40} 傷害。'], ['死戰', 'slam', '{120/120/120} 傷害。']]),
  xurong: P('xurong', '徐榮', '董卓中郎將', 'neutral', '戰士', 'halberd', { eye: 'fierce', beard: 'mustache', bulk: 1.15, size: 1.12, c: { armor: '#5a2a22', cloth: '#3a1a16', cape: '#7a2a22', plume: '#c0503a' } }, [
    ['鐵騎', 'charge', '衝撞造成 {160/160/160/160} 傷害。'], ['橫戟', 'crescent', '揮出戟氣，造成 {140/140/140/140} 傷害。'], ['圍殺', 'spin', '每圈 {70/70/70/70} 傷害。'], ['破陣', 'slam', '{220/220/220} 傷害。']]),
  huaxiong: P('huaxiong', '華雄', '董卓都督', 'neutral', '戰士', 'sword', { eye: 'fierce', beard: 'bushy', bulk: 1.25, size: 1.2, skin: '#d0a070', c: { armor: '#6a2a1a', cloth: '#3a1a12', cape: '#8a2a1a', plume: '#e06030' } }, [
    ['關西刀', 'crescent', '揮出刀氣，造成 {130/130/130/130} 傷害。'], ['猛衝', 'charge', '衝撞造成 {100/100/100/100} 傷害。'], ['旋刀', 'spin', '每圈 {60/60/60/60} 傷害。'], ['斬將', 'slam', '躍起重劈，造成 {180/180/180} 傷害。']]),
  hanzhong: P('hanzhong', '韓忠', '南陽黃巾', 'neutral', '戰士', 'axe', { head: 'headband', eye: 'fierce', beard: 'bushy', bulk: 1.2, size: 1.15, c: { armor: '#b8902a', cloth: '#6a5530', cape: '#e0b02a', band: '#f2c230', plume: '#f2c230' } }, [
    ['黃天斧', 'crescent', '造成 {140/140/140/140} 傷害。'], ['蠻衝', 'charge', '衝撞造成 {110/110/110/110} 傷害。'], ['旋斧', 'spin', '每圈 {60/60/60/60} 傷害。'], ['劈山', 'slam', '{190/190/190} 傷害。']]),
  huangzu: P('huangzu', '黃祖', '江夏太守', 'neutral', '戰士', 'sword', { beard: 'long', bulk: 1.15, c: { armor: '#3e5a5a', cloth: '#2e4646', cape: '#4a6a6a', plume: '#6a9a8a' } }, [
    ['揮刀', 'crescent', '造成 {120/120/120/120} 傷害。'], ['突圍', 'charge', '衝撞造成 {90/90/90/90} 傷害。'], ['迴刀', 'spin', '每圈 {50/50/50/50} 傷害。'], ['困獸', 'slam', '{160/160/160} 傷害。']]),
  dongxi: P('dongxi', '董襲', '孫權部將', 'wu', '戰士', 'sword', { bulk: 1.2, size: 1.12, beard: 'bushy' }, [
    ['斷紲', 'crescent', '揮刀造成 {90/90/90/90} 傷害。'], ['敢死', 'charge', '衝撞造成 {70/70/70/70} 傷害。'], ['兩鎧', 'shield', '護身。'], ['突入', 'slam', '{140/140/140} 傷害。']]),
  handang: P('handang', '韓當', '字義公', 'wu', '戰士', 'sword', { beard: 'mustache', c: { cape: '#a83a2a' } }, [
    ['弓馬', 'bolt', '射出一箭，造成 {80/120/160/200} 傷害。'], ['義公刀', 'crescent', '揮刀造成 {70/110/150/190} 傷害。'], ['宿將', 'buff', '強化自身。'], ['先登', 'charge', '衝撞造成 {150/250/350} 傷害。']]),
  zhuran: P('zhuran', '朱然', '字義封', 'wu', '戰士', 'spear', { c: { cape: '#a83a2a' } }, [
    ['截道', 'charge', '衝撞造成 {80/80/80/80} 傷害。'], ['槍刺', 'crescent', '造成 {70/70/70/70} 傷害。'], ['堅守', 'shield', '護身。'], ['破營', 'slam', '{140/140/140} 傷害。']]),
  zhangzhao: P('zhangzhao', '張昭', '字子布', 'wu', '謀士', 'staff', { head: 'guan', beard: 'long', hair: '#d8d4cc', c: { armor: '#5a3a30', cloth: '#6a2a24', cape: null } }, [
    ['諫', 'bolt', '{40/40/40/40}'], ['議', 'buff', '。'], ['輔', 'shield', '。'], ['託', 'heal', '。']]),
  qunchen: P('qunchen', '群臣', '孫權臣屬', 'wu', '謀士', 'staff', { head: 'guan', beard: 'goatee', c: { armor: '#4a4a5a', cloth: '#3a3a4a', cape: null } }, [
    ['議', 'bolt', '{30/30/30/30}'], ['論', 'buff', '。'], ['守', 'shield', '。'], ['退', 'heal', '。']]),
  // 列傳用的呂布：樣子同中立首領呂布，招式傷害調低（列傳是一個人對他，不是五個人圍）
  lubu: Object.assign({}, SG.LUBU, { skills: SG.LUBU.skills.map((k, i) => Object.assign({}, k, { desc: k.desc.replace(/\{[^}]+\}/, `{${[80, 140, 110, 190][i]}/${[80, 140, 110, 190][i]}/${[80, 140, 110, 190][i]}/${[80, 140, 110, 190][i]}}`) })) }),
  yanliang: P('yanliang', '顏良', '袁紹大將', 'neutral', '戰士', 'guandao', { eye: 'fierce', beard: 'bushy', bulk: 1.2, size: 1.15, c: { armor: '#7a5a2a', cloth: '#5a4220', cape: '#a07830', plume: '#d0a040' } }, [
    ['大刀', 'crescent', '造成 {100/100/100/100} 傷害。'], ['衝陣', 'charge', '衝撞造成 {80/80/80/80} 傷害。'], ['迴刀', 'spin', '每圈 {50/50/50/50} 傷害。'], ['猛劈', 'slam', '{140/140/140} 傷害。']]),
  wenchou: P('wenchou', '文醜', '袁紹大將', 'neutral', '戰士', 'spear', { eye: 'fierce', beard: 'goatee', bulk: 1.2, size: 1.15, c: { armor: '#6a4a2a', cloth: '#4a3a20', cape: '#906820', plume: '#c09030' } }, [
    ['長槍', 'crescent', '造成 {90/90/90/90} 傷害。'], ['驍騎', 'charge', '衝撞造成 {80/80/80/80} 傷害。'], ['亂刺', 'spin', '每圈 {45/45/45/45} 傷害。'], ['挑落', 'slam', '{130/130/130} 傷害。']]),
  kezi: P('kezi', '許貢門客', '刺客', 'neutral', '刺客', 'sword', { eye: 'fierce', c: { armor: '#2a2a2a', cloth: '#1a1a1a', cape: '#2a2a2a', plume: '#444444' } }, [
    ['暗刃', 'crescent', '造成 {110/110/110/110} 傷害。'], ['伏擊', 'charge', '衝撞造成 {90/90/90/90} 傷害。'], ['亂刀', 'spin', '每圈 {50/50/50/50} 傷害。'], ['報仇', 'slam', '{160/160/160} 傷害。']]),
};
